

export class DeviceModelPortAllocationUpdateInput implements IDeviceModelPortAllocationUpdateInput {
    /** The auto-generated id of the deviceModelPortAllocation master */
    deviceModelPortAllocationId!: number;
    /** The deviceModelPortAllocation name with 255 character limit */
    deviceModelPortAllocationName!: string;

    constructor(data?: IDeviceModelPortAllocationUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceModelPortAllocationId = _data["deviceModelPortAllocationId"];
            this.deviceModelPortAllocationName = _data["deviceModelPortAllocationName"];
        }
    }

    static fromJS(data: any): DeviceModelPortAllocationUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelPortAllocationUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceModelPortAllocationId"] = this.deviceModelPortAllocationId;
        data["deviceModelPortAllocationName"] = this.deviceModelPortAllocationName;
        return data; 
    }
}

export interface IDeviceModelPortAllocationUpdateInput {
    /** The auto-generated id of the deviceModelPortAllocation master */
    deviceModelPortAllocationId: number;
    /** The deviceModelPortAllocation name with 255 character limit */
    deviceModelPortAllocationName: string;
}

